import React from "react";
import { useImmerReducer } from "use-immer";
import StateContext from "./StateContext";
import DispatchContext from "./DispatchContext";

const initialState = {
    jwtAccessToken: localStorage.getItem("jwtAccessToken"),
    jwtRefreshToken: localStorage.getItem("jwtRefreshToken"),
    userId: localStorage.getItem("userId"),
    userUsername: localStorage.getItem("userUsername"),
    userEmail: localStorage.getItem("userEmail"),
    userIsLogged: !!localStorage.getItem("jwtAccessToken"),
    isLoaded: false,
    userProfile: null,
    allGeologicalObjects: {},
    allMineralWaters: {},
    allParishes: [],
    allTelepulesek: [],
    allSzekek: [],
    allMegyek: [],
    allHelynevek: [],
    isSzftMember: localStorage.getItem("isSzftMember") === "true",
};

function reducer(draft, action) {
    switch (action.type) {
        case "catchToken":
            draft.jwtAccessToken = action.tokenValue;
            draft.jwtRefreshToken = action.refreshToken;
            draft.userIsLogged = true;
            localStorage.setItem("jwtAccessToken", action.tokenValue);
            localStorage.setItem("jwtRefreshToken", action.refreshToken);
            break;
        case "userSignsIn":
            draft.userId = action.IdInfo;
            draft.userUsername = action.usernameInfo;
            draft.userEmail = action.emailInfo;
            draft.userIsLogged = true;
            localStorage.setItem("userId", action.IdInfo);
            localStorage.setItem("userUsername", action.usernameInfo);
            localStorage.setItem("userEmail", action.emailInfo);
            break;
        case "logout":
            draft.jwtAccessToken = null;
            draft.jwtRefreshToken = null;
            draft.userId = null;
            draft.userUsername = null;
            draft.userEmail = null;
            draft.userIsLogged = false;
            draft.isLoaded = false;
            draft.userProfile = null;
            draft.isSzftMember = false;
            localStorage.removeItem("jwtAccessToken");
            localStorage.removeItem("jwtRefreshToken");
            localStorage.removeItem("userId");
            localStorage.removeItem("userUsername");
            localStorage.removeItem("userEmail");
            localStorage.removeItem("isSzftMember");
            break;
        case "catchUserProfileInfo":
            draft.userProfile = action.profile;
            draft.isLoaded = true;
            draft.isSzftMember = action.profile.is_szft_member;
            localStorage.setItem("isSzftMember", action.profile.is_szft_member);
            break;
        case "setGeologicalObjects":
            draft.allGeologicalObjects = action.data;
            break;
        case "setMineralWaters":
            draft.allMineralWaters = action.data;
            break;
        case "appendParishes":
            draft.allParishes.push(...action.data);
            break;
        case "setParishes":
            draft.allParishes = action.data;
            break;
        case "appendTelepulesek":
            draft.allTelepulesek.push(...action.data);
            break;
        case "setTelepulesek":
            draft.allTelepulesek = action.data;
            break;
        case "appendSzekek":
            draft.allSzekek.push(...action.data);
            break;
        case "setSzekek":
            draft.allSzekek = action.data;
            break;
        case "appendMegyek":
            draft.allMegyek.push(...action.data);
            break;
        case "setMegyek":
            draft.allMegyek = action.data;
            break;
        case "appendHelynevek":
            draft.allHelynevek.push(...action.data);
            break;
        case "setHelynevek":
            draft.allHelynevek = action.data;
            break;
        case "getMap":
            draft.map = action.mapData;
            break;
        default:
            break;
    }
}

function GlobalStateProvider({ children }) {
    const [state, dispatch] = useImmerReducer(reducer, initialState);
    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>
                {children}
            </DispatchContext.Provider>
        </StateContext.Provider>
    );
}
export default GlobalStateProvider;
